export const AppName = () => (
  <span className="font-inter-semibold text-[16px]">Target Sales</span>
);
